import React from "react";
import Button from "components/Button";
import useTranslation from "next-translate/useTranslation";
import { ArrowRightIcon } from "@heroicons/react/outline";

export default function Actions({ label }) {
  const { t } = useTranslation("common");

  return (
    <div>
      <Button type="submit">
        <span className="flex items-center gap-2">
          <span>{label || t("send")}</span>
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
        </span>
      </Button>
    </div>
  );
}
